import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/sept-oct2021/ads/Challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Challenger School ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/altabank.jpg',
      link: 'https://www.altabank.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Altabank ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/seiner.jpg',
      link: 'https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Jerry Seiner Cadillac ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/BMW-Of-Murray.jpg',
      link: 'https://www.bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'BMW of Utah ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/hamilton.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Hamilton Park Interiors ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/cultural-enterprise.jpg',
      link: 'https://www.williamcall.net/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'William Call ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/LHMiller-Lexus.jpg',
      link: 'https://www.lhmlexus.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Larry H. Miller Lexus ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/RCWilley.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'RC Willey ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/Rubys_Inn_fall.jpg',
      link: 'https://rubysinn.com/fallstagearts',
      alt: 'Rubys Inn ad',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/ads/UniversityCU.jpg',
      link: 'https://www.ucreditu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'University of Utah Credit Union ad',
      class: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <br />
      <br />
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
